import CloseIcon from "@mui/icons-material/Close";

function normalizeRows(product) {
  const list = product?.especificacoesLista;
  if (Array.isArray(list) && list.length > 0) {
    return { mode: "lista", lista: list };
  }
  const text = (product?.specs || "").trim();
  if (text) {
    return {
      mode: "texto",
      linhas: text.split(";").map((s) => s.trim()).filter(Boolean),
    };
  }
  return { mode: "vazio" };
}

export default function SpecsModal({
  open,
  product,
  onClose,
  brandColors,
  selectedBrand,
}) {
  if (!open || !product) return null;

  const isKarstenLayout = selectedBrand === "karsten";
  const data = normalizeRows(product);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 60,
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: brandColors.surface,
          borderRadius: "8px",
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          padding: "24px",
          maxWidth: "min(560px, 100%)",
          width: "100%",
          textAlign: "left",
          maxHeight: "85vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "16px",
          }}
        >
          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                fontFamily: "inherit",
              }}
            >
              {product.name}
            </h3>
            <p
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: brandColors.primary,
              }}
            >
              Especificações
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              color: brandColors.textMuted,
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
            onMouseEnter={(e) =>
              (e.target.style.color = brandColors.textBase)
            }
            onMouseLeave={(e) =>
              (e.target.style.color = brandColors.textMuted)
            }
          >
            <CloseIcon style={{ fontSize: "24px" }} />
          </button>
        </div>
        <div
          style={{
            fontSize: "14px",
            color: brandColors.textMuted,
            backgroundColor: isKarstenLayout ? "#f9fafb" : brandColors.bg,
            padding: "16px",
            borderRadius: "8px",
          }}
        >
          {data.mode === "lista" && (
            <dl style={{ margin: 0 }}>
              {data.lista.map((row, idx) => {
                const v1 = (row.valor1 || "").trim();
                const v2 = (row.valor2 || "").trim();
                const merged = `${v1} ${v2}`.trim();
                const combined = (row.valor || "").trim();
                const showValorPartes =
                  (v1 || v2) &&
                  (merged !== combined || !combined);

                return (
                <div
                  key={`${row.idEspecificacao ?? "esp"}-${idx}`}
                  style={{
                    marginTop: idx > 0 ? "14px" : 0,
                    paddingBottom: idx < data.lista.length - 1 ? "14px" : 0,
                    borderBottom:
                      idx < data.lista.length - 1
                        ? `1px solid ${brandColors.border}`
                        : "none",
                  }}
                >
                  {row.descricao ? (
                    <dt
                      style={{
                        fontWeight: 700,
                        color: brandColors.textBase,
                        marginBottom: "6px",
                        fontSize: "13px",
                      }}
                    >
                      {row.descricao}
                    </dt>
                  ) : null}
                  <dd style={{ margin: 0 }}>
                    {combined ? (
                      <p style={{ margin: "0 0 6px 0", lineHeight: 1.45 }}>
                        {combined}
                      </p>
                    ) : null}
                    {showValorPartes ? (
                      <div
                        style={{
                          fontSize: "13px",
                          lineHeight: 1.5,
                          opacity: 0.95,
                        }}
                      >
                        {v1 ? (
                          <p style={{ margin: "4px 0 0 0" }}>
                            <span style={{ fontWeight: 600 }}>Valor 1: </span>
                            {v1}
                          </p>
                        ) : null}
                        {v2 ? (
                          <p style={{ margin: "4px 0 0 0" }}>
                            <span style={{ fontWeight: 600 }}>Valor 2: </span>
                            {v2}
                          </p>
                        ) : null}
                      </div>
                    ) : null}
                    {row.aplicacaoEspecificacao != null &&
                    row.aplicacaoEspecificacao !== "" ? (
                      <p
                        style={{
                          margin: "8px 0 0 0",
                          fontSize: "12px",
                          color: brandColors.textMuted,
                        }}
                      >
                        Aplicação: {String(row.aplicacaoEspecificacao)}
                      </p>
                    ) : null}
                  </dd>
                </div>
              );
              })}
            </dl>
          )}
          {data.mode === "texto" &&
            data.linhas.map((line, idx) => (
              <p key={idx} style={{ margin: idx > 0 ? "8px 0 0 0" : 0 }}>
                {line}
              </p>
            ))}
          {data.mode === "vazio" && "Sem especificações disponíveis."}
        </div>
      </div>
    </div>
  );
}
